<script lang="ts">
	import { NodeViewWrapper } from "svelte-tiptap";
	import { twMerge } from "tailwind-merge";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Node, NodeViewProps } from "@tiptap/core";
	import type { Node as PMNode } from "@tiptap/pm/model";

	type $$Props = NodeViewProps;
	export let node: PMNode;
	export let extension: Node;
	export let selected: boolean;

	$: provider = extension.options.provider as TokenProvider;
</script>

<NodeViewWrapper as="div">
	<div class={twMerge("w-fit overflow-hidden rounded", selected && "ring-4")} contentEditable="false" draggable="true" data-drag-handle>
		{#if provider.hasSubstitutionToken(node.attrs.src)}
			<div class="flex h-48 w-72 items-center justify-center bg-gray-200 text-gray-700">{provider.token(node.attrs.src)?.label}</div>
		{:else}
			<img src={node.attrs.src} alt={node.attrs.alt} />
		{/if}
	</div>
</NodeViewWrapper>
